<script lang="ts">
	import theme from 'stores/theme';
	import { DefaultListItem, PortableText } from '@portabletext/svelte';
	import LinkBack from 'components/LinkBack/LinkBack.svelte';
	import KeyTermsSection from 'components/LearnPage/KeyTermsSection/KeyTermsSection.svelte';
	import SanityImage from 'components/SanityImage/SanityImage.svelte';
	import MoreBtn from 'components/LearnPage/MoreBtn/MoreBtn.svelte';
	import activeLocale from 'stores/activeLocale';
	import { _ } from 'svelte-i18n';
	import SanityTable from 'components/SanityTable/SanityTable.svelte';
	import MetaTags from 'components/MetaTags/MetaTags.svelte';

	$: dark = $theme;

	export let data;

	$: ({ keyTerm } = data);

	$: normalizedLocale = $activeLocale.locale === 'en' ? '' : `${$activeLocale.locale}/`;
</script>

<MetaTags title={`${keyTerm.metaTitle} | CryptoMarketCap`} description={keyTerm.metaDescription} />

<section class="term" class:dark>
	<div class="term-head">
		<div class="back-btn">
			<LinkBack to="/learn/glossary" />
		</div>
		<h1 class="term-title">{keyTerm.title}</h1>
	</div>
	<div class="term-content typography-page" class:dark>
		<PortableText
			value={keyTerm.body}
			components={{
				types: {
					image: SanityImage,
					table: SanityTable,
				},
				listItem: {
					normal: DefaultListItem,
				},
			}}
			context={{ dark }}
		/>
	</div>
	{#if keyTerm.related && keyTerm.related.length > 0}
		<h2 class="term-title related">{$_('learn.relatedTerms')}</h2>
		<div class="rest-terms">
			<KeyTermsSection keyTerms={keyTerm.related} {dark} class="no-padding" />
		</div>
	{/if}
</section>

<MoreBtn
	as="link"
	linkTo={`/learn/glossary/${normalizedLocale}`}
	title={$_('learn.readAllTerms')}
	class={null}
/>

<style lang="scss">
	@import 'term';
</style>
